import { IBayPattern } from "./types/IPositionPatterns";
import { ILidData } from "open-vessel-definition";
import { pad3 } from "@tedivo/tedivo-pure-helpers";

/**
 * Returns every 20' isoBay a lid lies over, not only its start and end bays.
 * Loose on purpose: the range is taken in either order, and an even (40') bound
 * widens to both 20' bays of that pair, so a lid is shown in every bay it touches.
 */
export function getIsoBaysUnderLid(
  lid: Pick<ILidData, "startIsoBay" | "endIsoBay">,
): IBayPattern[] {
  const start = Number(lid.startIsoBay);
  const end = Number(lid.endIsoBay);
  if (!Number.isFinite(start) || !Number.isFinite(end)) return [];

  const lo = Math.max(1, Math.min(start, end) - 1);
  const hi = Math.max(start, end) + 1;

  const isoBays: IBayPattern[] = [];
  for (let b = lo % 2 ? lo : lo + 1; b <= hi; b += 2) isoBays.push(pad3(b) as IBayPattern);
  return isoBays;
}
